/**
 * 처방 목록 표 — 줄번호·약품명·용법·판정 등급 배지·정오 상태. 문제 줄(위험·1회 과량·경고) 강조.
 * 행 클릭 → 그 약 상세로 스크롤 + 펼침(핸들러는 페이지).
 * @spec:2026-09-29-처방검토-판정기록-조회화면 (상세 화면 개편)
 */
import React from "react";
import Tag from "components/atoms/Tag";
import { Table, Th, Tr, Td, DrugName } from "./layoutStyle";

export interface PrescriptionRow {
  index: number;
  name: string;
  dosage: string;
  /** 줄 전용 등급(강등 전 축 — cardBadge/severityLabel 재사용). 없으면 "—". */
  grade: { label: string; tone: React.ComponentProps<typeof Tag>["color"]; downgraded: boolean } | null;
  /** 위험·1회 과량·경고(di.isAlert) — 행 강조. */
  isProblem: boolean;
  /** 정오 상태 — 작성 중 / verdict / 미표기. */
  labelState: string;
}

export interface PrescriptionTableProps {
  rows: PrescriptionRow[];
  onRowClick: (index: number) => void;
}

const PrescriptionTable: React.FC<PrescriptionTableProps> = ({ rows, onRowClick }) => (
  <Table data-testid="dose-prescription-table">
    <thead>
      <tr>
        <Th>줄</Th>
        <Th>약품명</Th>
        <Th>용법</Th>
        <Th>판정</Th>
        <Th>정오</Th>
      </tr>
    </thead>
    <tbody>
      {rows.map((r) => (
        <Tr
          key={r.index}
          $problem={r.isProblem}
          data-testid="dose-prescription-row"
          data-index={r.index}
          data-problem={r.isProblem ? "true" : "false"}
          onClick={() => onRowClick(r.index)}
        >
          <Td>{r.index + 1}</Td>
          <Td>
            <DrugName>{r.name}</DrugName>
          </Td>
          <Td>{r.dosage}</Td>
          <Td>
            {r.grade ? (
              <Tag size="Small" variant={r.grade.downgraded ? "Outlined" : "Tinted"} color={r.grade.tone}>
                {r.grade.label}
              </Tag>
            ) : (
              "—"
            )}
          </Td>
          <Td data-testid="dose-prescription-label-state">{r.labelState}</Td>
        </Tr>
      ))}
    </tbody>
  </Table>
);

export default PrescriptionTable;
